<template>
    <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-card class="elevation-12">
                    <v-toolbar color="secondary" dark>
                        <v-toolbar-title>Reset Password</v-toolbar-title>
                    </v-toolbar>
                    <v-form v-if="!submitted" ref="form" @submit="sendEmail" @submit.prevent>
                        <v-card-text>
                            Please enter your email address below and we will send you a link to reset your password.
                            <v-text-field label="Email" prepend-icon="mdi-account" v-model="email" type="text" :rules="emailRules" required />
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn type="submit">Submit</v-btn>
                        </v-card-actions>
                    </v-form>
                    <v-form v-if="submitted">
                        <v-card-text >Please check your email, we've sent you a link to reset your password.</v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn @click="login">Login</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios'
    export default {
        data() {
            return {
                email: '',
                submitted: false,
                emailRules: [
                    v => !!v || 'email is required'
                ]
            };
        },
        methods: {
            async sendEmail() {
                this.submitted = true;
                var body = { EmailAddress: this.email };
                await axios.post('api/Security/RequestPasswordReset', body);
            },
            login() {
                this.$router.push("/login");
            },
        }
    };
</script>
